export const farm = {
  viewScheme: '[perm]-[farm]-view-individuals-location-scheme',
  addIndividualToCell: '[perm]-[farm]-add-individual-to-cell',
  freeCellFromIndividual: '[perm]-[farm]-free-cell-from-individual',
  editScheme: '[perm]-[farm]-edit-individuals-location-scheme',
  cleanFacility: '[perm]-[farm]-clean-facility',
} as const;
